import {ChangeDetectionStrategy, Component} from '@angular/core'

@Component({
  selector: 'cft-tooltip',
  template: `<ng-content />`,
  styles: `
    @reference '../../../styles/app-reference.css';

    :host {
      @apply w-[calc(100%-_2rem)] sm:w-max sm:max-w-68;
      @apply px-md py-xs;
      @apply bg-president-800 text-grey-200;
      @apply shadow-1;
      @apply rounded-md border border-president-50;
      @apply z-10;
      @apply border-2;
    }
  `,
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TooltipComponent {}
